import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { CreateInvoice } from "../screens";
import { InvoiceScreen, InvoicesScreen } from "./screens";

const InvoiceRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <InvoicesScreen />
      </Route>
      <Route path={`${path}/create`}>
        <CreateInvoice />
      </Route>
      <Route path={`${path}/:invoiceId`}>
        <InvoiceScreen />
      </Route>
    </Switch>
  );
};

export default InvoiceRouter;
